import React from 'react';
import PropTypes from 'prop-types';

import {Typography, Stack, Button, Box} from 'views/components';
import {ChangeCircleOutlined} from 'views/icons';
import {Translate, translate} from 'views/module';

import TimelineCard from './TimelineCard';

import moment from 'moment';

const ShiftRequestedReschedule = (props) => {
  const {reschedule, caregiverData, setModel, status} = props;

  const timeString = moment(reschedule.createdAt).format('LLL');
  const rescheduleReason = reschedule.data.rescheduleReason || translate('schedule.eventDetail.EventTimelineSection.ShiftRequestedReschedule.NoReason');
  const rescheduledDate = reschedule.data.dateString;
  const rescheduledTime = reschedule.data.timeString;
  const isDeclined = reschedule.adminAction?.status === 'DECLINED';

  const onReschedule = async (e) => {
    setModel('ACCEPT_RESCHEDULE_REQUEST');
  };

  const togglePopup = async () => {
    setModel('DECLINE_RESCHEDULE_REQUEST');
  };

  return (
    <Box>
      <TimelineCard
        timeString={timeString}
        icon={ChangeCircleOutlined}
        iconColor="#cf8842"
        timeBg="#e0e0e0"
        title={<Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedReschedule.Title' />}
      >
        <Stack spacing={1}>
          <Typography variant="body2" color="text.secondary">
            <Translate
              expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedReschedule.Description'
              substitute={{caregiverName: caregiverData.caregiverDetail.caregiverName, date: rescheduledDate, time: rescheduledTime}}
            />
          </Typography>
          <Typography fontWeight="bold" fontSize={'14px'}>
            <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedReschedule.Reason'/>
          </Typography>
          <Typography color="text.secondary" fontSize={'14px'}>{rescheduleReason}</Typography>

          {/* Accept and decline buttons */}
          {
            !isDeclined && status !== 'DEACTIVATED' &&
            <Stack
              direction={{xs: 'column', sm: 'row'}}
              spacing={1}
              sx={{
                '@media (min-width:600px)': {
                  display: 'inline-block',
                },
              }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={onReschedule}
                disabled={isDeclined}
              >
                <Translate expression="generic.Accept" />
              </Button>

              <Button
                variant="outlined"
                size="small"
                onClick={togglePopup}
                sx={{
                  'color': isDeclined ? 'red' : '',
                  'borderColor': isDeclined ? 'red' : '',
                  '&:hover': {
                    borderColor: isDeclined ? 'error.dark' : 'primary.main',
                    backgroundColor: isDeclined ? 'rgba(255, 0, 0, 0.4)' : 'transparent',
                  },
                }}
                disabled={isDeclined}
              >
                {isDeclined ? 'Declined' : <Translate expression="generic.Decline" />}
              </Button>
            </Stack>
          }
          {/* Display declined status */}
          {
            isDeclined &&
            <Box
              sx={{
                display: 'inline-block',
                border: '1px solid',
                borderColor: 'error.main',
                color: 'error.main',
                bgcolor: 'rgba(255, 0, 0, 0.05)',
                borderRadius: '4px',
                padding: '1px 12px',
                width: 'fit-content',
              }}
            >
              <Typography
                variant="caption"
                sx={{
                  fontWeight: 500,
                }}
              >
                <Translate expression='schedule.eventDetail.EventTimelineSection.ShiftRequestedReschedule.RequestDeclined'/>
              </Typography>
            </Box>
          }

        </Stack>
      </TimelineCard>
    </Box>
  );
};

ShiftRequestedReschedule.propTypes = {
  reschedule: PropTypes.shape({
    createdAt: PropTypes.string.isRequired,
    data: PropTypes.shape({
      rescheduleReason: PropTypes.string,
      dateString: PropTypes.string,
      timeString: PropTypes.string,
    }).isRequired,
    event: PropTypes.shape({
      eventData: PropTypes.any,
      clientRn: PropTypes.any,
      eventRn: PropTypes.any,
    }),
    adminAction: PropTypes.shape({
      status: PropTypes.string,
      reason: PropTypes.string,
    }),
  }).isRequired,
  caregiverData: PropTypes.shape({
    caregiverDetail: PropTypes.shape({
      caregiverName: PropTypes.string,
    }),
  }).isRequired,
  setModel: PropTypes.func.isRequired,
  status: PropTypes.string,
};

export default ShiftRequestedReschedule;
